// extracted by mini-css-extract-plugin
export default {"container":"RadarChart_container__iUWWj","label":"RadarChart_label__1mP-k","weakLabel":"RadarChart_weakLabel__oJdbQ"};